// ******** Confirmação Agendamento *********
// app/PrestadorProfile/confirmacacaoagendamento.jsx // nome anterior
// app/PrestadorProfile/profissionalconfirmacacaoagendamento.jsx // nome novo
// ******** autor: WdePaula / Microvolution
// ******** data: 21/07/24
// ******** alterações: 22/8/24w | 11h10
// ******** alterações: 20/10/24w | 11h29 | acrescentamos nome e endereço do estabelcimento no final do agendamento
// ******** alterações: 25/10/24w | 14h50 | acrescentado o envio de mensagem automática para o whatsapp
// ******** alterações: 28/12/24w | 14h32 | modificado o nome do arquivo: de "confirmacacaoagendamento.jsx" para "profissionalconfirmacaoagendamento.jsx"
// ***********************************




import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import imgLogomarca from '../../../../Assets/agendex/logoagendexcliente.png';
import imgLogoMini from '../../../../Assets/agendex/iconLogoAgendex.png';
import Footer from '../../components/Footer/footer';

import './profissionalconfirmacaoagendamento.css';

const ConfirmacaoAgendamento = () => {
    const { state } = useLocation();
    // console.log('state: ', state);
    const [servicoNome, setServicoNome] = useState(state?.servicoNome || null);
    const [servicoData, setServicoData] = useState(state?.servicoData || null);
    const [servicoHorario, setServicoHorario] = useState(state?.servicoHorario || null);
    const [servicoValor, setServicoValor] = useState(state?.servicoValor || null);
    // const [valorServico, setValorServico] = useState('');
    const [profissionalNome, setProfissionalNome] = useState(state?.profissionalNome || null);
    const [fotoPerfil, setFotoPerfil] = useState(state?.fotoPerfil || null);
    const [empresaNome, setEmpresaNome] = useState(state?.empresaNome || null);
    const [empresaEndereco, setEmpresaEndereco] = useState(state?.empresaEndereco || null);
    // const [empresaCelular, setEmpresaCelular] = useState(null);
    const [empresaCelular, setEmpresaCelular] = useState(state?.empresaCelular || null);
    // console.log('empresaCelular :', empresaCelular);
    const [clienteNome, setClienteNome] = useState(state?.nomeCliente || null);
    const [clienteFone, setClienteFone] = useState(state?.celularCliente || null);
    
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const { linkpersonalizado, id, profId, servId, reservaId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        // Rola a página para o topo ao montar o componente
        window.scrollTo({ top: 0, behavior: 'smooth' });

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        
        // // empresaCelular != null && handleEnviarAgendamentoViaWhats();
        // // console.log('empresaCelular e whatsappNumber', empresaCelular, whatsappNumber);
        // if (empresaCelular && whatsappNumber) {
        //     // Chama a função somente se empresaCelular não for null
        //     handleEnviarAgendamentoViaWhats();
        // }
        // SEMPRE chama a função, e ela que decide se pode abrir o WhatsApp
        setTimeout(() => {
            handleEnviarAgendamentoViaWhats();
        }, 1000);

        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, []);

    // **********função modificada por outra abaixo para melhorar a experiência do usuário 4/10/25w19h24w
    // const handleEnviarAgendamentoViaWhats = () => {
    //     window.open(`https://wa.me/${whatsappNumber}?text=${whatsappMessageEnviarAgendamento}`, '_blank');
    // };
    // **********função modificada por outra abaixo para melhorar a experiência do usuário 4/10/25w19h24w
    const handleEnviarAgendamentoViaWhats = () => {
        // console.log('handleEnviarAgendamentoViaWhats ', empresaCelular);
        // if (!empresaCelular) {
            // console.log('handleEnviarAgendamentoViaWhats - empresaCelular:', empresaCelular);
            // console.log('handleEnviarAgendamentoViaWhats - tipo:', typeof empresaCelular);
            
            // Validação mais robusta para null, undefined ou string vazia
            if (!empresaCelular || empresaCelular === 'null' || empresaCelular === 'undefined' || empresaCelular === '') {
                console.warn('Celular da empresa não cadastrado - WhatsApp não será aberto');
                Swal.fire({
                    icon:   'info',
                    title:  'Agendamento Confirmado',
                    text:   'Seu agendamento foi realizado com sucesso!',
                    confirmButtonText: 'OK'
            });
            return;
        }
        
        if (whatsappNumber) {
            window.open(`https://wa.me/${whatsappNumber}?text=${whatsappMessageEnviarAgendamento}`, '_blank');
        }
    };

    // Número do WhatsApp do estabelecimento
    // const whatsappNumber = encodeURIComponent(`${empresaCelular}`);
    // const whatsappNumber = encodeURIComponent(empresaCelular.replace(/\D/g, '')); // Remove caracteres não numéricos
    // Número do WhatsApp do estabelecimento com código do país Brasil (55)
    // const whatsappNumber = `55${empresaCelular.replace(/\D/g, '')}`;
    const whatsappNumber = empresaCelular ? `55${empresaCelular.replace(/\D/g, '')}` : null;
    // console.log(whatsappNumber);

    // Construir a mensagem personalizada para WhatsApp
    const whatsappMessageEnviarAgendamento = encodeURIComponent(
`****************************
    MEU AGENDAMENTO
    CLIENTE: ${clienteNome || "Nome cliente não informado"}
    TELEFONE: ${clienteFone || "Telefone do cliente não informado"}
    ****************************
    PROFISSIONAL: ${profissionalNome || "Profissional não informado"}
    SERVIÇO: ${servicoNome || "Serviço não informado"}
    VALOR: ${servicoValor || "Valor não informado"}
    DATA: ${servicoData || "Data não informada"}
    HORÁRIO: ${servicoHorario || "Horário não informado"}
    ****************************
    COMPROVANTE DE AGENDAMENTO
****************************`
    );

    const handleNovoAgendamento = () => {
        navigate(`/agendar/${linkpersonalizado}`);
    };

    const handleAlterarAgendamento = () => {
        // Lógica para alterar o agendamento
        // Pode ser uma navegação para a página de agendamento ou exibição de um modal
        Swal.fire('Atenção', 'Função de "alteração" não disponível nesta versão. Baixe o app Agendex Cliente na Google Play', 'info');
    };

    const handleCancelarAgendamento = () => {
        // Lógica para cancelar o agendamento
        // Pode ser uma navegação para a página de cancelamento ou exibição de um modal
        Swal.fire('Atenção', 'Função de "cancelamento" não disponível nesta versão. Baixe o app Agendex Cliente na Google Play', 'info');
    };



    return (
        <div className="container-fluid">
            <div className="row flex-nowrap">
                {/* (servicoValor === 0 ? (Valor a combinar : {servicoValor})) */}
                <div className="col py-3 me-3 text-center">
                    <img src={isMobile ? imgLogoMini : imgLogomarca} className={`img-logo ${isMobile ? 'img-logo-mobile' : 'img-logo-desktop'}`} alt="logo agendex"/>
                    <br/>
                    <h2>Agendamento Realizado!</h2>
                    <button className='btn btn-primary btn-lg'onClick={handleNovoAgendamento} data-toggle="tooltip" data-placement="button" title="clique aqui se deseja marcar um novo agendamento nesta empresa"><i className="bi bi-calendar-plus-fill"></i> Iniciar Novo Agendamento</button>
                    <div className="agendamento-info">
                        <p><strong>Data: {servicoData}</strong> {/* Inserir a data do agendamento */}</p>
                        <p><strong>Horário: {servicoHorario} hs</strong> {/* Inserir o horário do agendamento */}</p>
                        <p><strong>Serviço: {servicoNome}</strong> {/* Inserir o nome do serviço */}</p>
                        <p><strong>Valor: {servicoValor}</strong> {/*Inserir o valor do serviço*/}</p>
                        {/* <p><strong>Valor: {valorServico}</strong> Inserir o valor do serviço</p> */}
                        <p><strong>Profissional: {profissionalNome}</strong> {/* Inserir o nome do profissional */}</p>
                        <p><strong>Estabelecimento: {empresaNome}</strong> {/* Inserir o nome da empresa */}</p>
                        <p><strong>Endereço: {empresaEndereco}</strong> {/* Inserir o nome da empresa */}</p>
                        <br />
                        <button className='btn btn-warning p-10' disabled onClick={handleAlterarAgendamento} data-toggle="tooltip" data-placement="top" title="função indisponível nesta versão">
                            Alterar Agendamento
                        </button>
                        <button className='btn btn-danger ml-10 mt-10' onClick={handleCancelarAgendamento} data-toggle="tooltip" data-placement="top" title="Clique para cancelar este agendamento">
                            Cancelar Agendamento
                        </button>
                    </div>
                </div>
            </div>
            {fotoPerfil ? 
                (
                    <div className='text-center'>
                        <img src={fotoPerfil} alt={empresaNome} className='usuario-foto'/>
                    </div>
                ) : (
                    <p className='text-center'>{empresaNome}</p>
                )
            }
            {/* {console.log(servicoValor, servicoValor)}
            {servicoValor === 0 ? 
                (
                    setValorServico = ('Valor a combinar')
                ) : (
                    setValorServico = (servicoValor)
                )
            } */}

            <Footer/>
        </div>
    );
};

export default ConfirmacaoAgendamento;